/* ••[1]••••••••••••••••••••••••• VideoStatsModel.ts •••••••••••••••••••••••••••••• */
import { VanillaPoll } from "../core/interfaces/VanillaApi";
import ProviderFactory from "../core/ProviderFactory";

import {
  CommunityProviderType,
  ProviderConfiguration,
} from "../core/types/Provider";
import { isMode } from "../core/utilities";
import VanillaPollsProvider from "../core/providers/community/vanillaProviders/VanillaPollsProvider";

export default abstract class VideoStatsModel {
  private static provider: VanillaPollsProvider = ProviderFactory.create(
    CommunityProviderType.Polls,
    isMode("development")
      ? ProviderConfiguration.local
      : ProviderConfiguration.vanilla
  );

  public static async getPolls(): Promise<Array<VanillaPoll> | null> {
    const polls = await VideoStatsModel.provider.getPolls();
    return polls;
  }

  public static async answerWatchedReplayPoll(
    discussionId: string,
    userId: number,
    eventTitle: string,
    categoryId: number
  ) {
    //Only allow for HCM events for testing for now, remove after testing.....
    if (categoryId !== 28) {
      return null;
    }
    const polls = await VideoStatsModel.getPolls();
    let matchedPoll = polls.find((poll) =>
      poll.name.includes(`id:${discussionId}`)
    );

    if (!matchedPoll) {
      console.debug("No matching poll found. Creating new one...");
      const pollName = `id:${discussionId}-category:${categoryId}-${eventTitle}`;
      const isUAT = window.location.hostname.includes("-uat");
      const genericCategoryID = isUAT ? 736 : 779;
      matchedPoll =
        (await VideoStatsModel.provider.createPoll(
          pollName,
          genericCategoryID
        )) || null;
    }
    if (!matchedPoll?.pollID) {
      console.error("Failed to create or retrieve valid poll.");
      return null;
    }

    const pollId = matchedPoll.pollID;
    const pollOptionId = matchedPoll.pollOption.find((option) =>
      option.body.includes("yes")
    )?.pollOptionID;

    if (!pollOptionId) {
      console.debug("No valid poll option found.");
      return null;
    }

    return VideoStatsModel.provider
      .answerPoll(pollId, pollOptionId, userId)
      .then((response) => {
        console.debug("Answer poll response:", response);
        return response;
      })
      .catch((error: unknown) => {
        console.error("Error answering poll:", error);
        return null;
      });
  }
}
